import DetailedEvaluation from "../../Pages/DetailedEvaluation";
import { navigationMapBuilder } from "./helpers";

const navigation = [
  {
    header: "Detailed Evaluation",
    links: [
      {
        text: "Detailed Evaluation",
        icon: <></>,
        route: "",
        component: DetailedEvaluation,
      },
    ],
  },
];

const navigationMap = (parentRoute,layout) =>
  navigationMapBuilder(parentRoute, navigation,layout);

export default navigationMap;
